


























































import { Component, Vue, Prop } from 'vue-property-decorator';
import Modal from '@/components/common/Modal.vue';
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue';

@Component({
  components: {
    Modal,
    ScaleLoader,
  },
})
export default class ModalGeneratePdf extends Vue {
  @Prop()
  showGeneratePdf!: boolean;

  @Prop()
  closeGeneratePdf!: () => void;

  @Prop()
  createPdf!: () => Promise<void>;

  title = 'Generate PDF';
  description = `Do you want to generate PDF for all questions in this collection? 
  Make sure the order of the questions is looking good and delete any question you do not need in the pdf.`;
  width = '600px';

  isLoading = false;

  async generatePdfClicked() {
    if (this.isLoading) return;

    this.isLoading = true;

    await this.createPdf();

    this.closeGeneratePdf();
    this.isLoading = false;
  }

  cancelClick() {
    this.closeGeneratePdf();
  }

  spinnerStyle = {
    backgroundColor: '#F52E00',
    height: '86px',
    width: '6px',
    margin: '7px',
    borderRadius: '200px',
    display: 'inline-block',
    animationName: 'v-scaleStretchDelay',
    animationDuration: '1s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'cubic-bezier(.2,.68,.18,1.08)',
    animationFillMode: 'both',
  };
  spinnerDelay1 = {
    animationDelay: '0.1s',
  };
  spinnerDelay2 = {
    animationDelay: '0.2s',
  };
  spinnerDelay3 = {
    animationDelay: '0.3s',
  };
  spinnerDelay4 = {
    animationDelay: '0.4s',
  };
  spinnerDelay5 = {
    animationDelay: '0.5s',
  };
  spinnerDelay6 = {
    animationDelay: '0.6s',
  };
  spinnerDelay7 = {
    animationDelay: '0.7s',
  };
  spinnerDelay8 = {
    animationDelay: '0.8s',
  };
}
